import userService from '@/components/service/UserService';

/**
 * 用户角色权限验证
 * 系统角色：0管理员 1普通用户 2超级管理员，多角色验证，满足一个则显示（$useRoleAuths(['xx', 'xx'])）
 * @param {string[]} roles 功能所对应的角色
 */
export function useRoleAuths(roles) {
  // 当前用户角色
  const myRole = userService.getUser().role.authority;
  return roles.includes(myRole);
}

/**
 * 用户单位类型权限验证
 * 系统单位类型：1公园 2林场 3园林绿化大数据中心，多单位类型验证，满足一个则显示（$useDeptAuths([1, 2])）
 * @param {number[]} deptTypes 功能所对应的单位类型
 */
export function useDeptAuths(deptTypes) {
  // 当前用户单位类型
  const myDeptType = userService.getUser().deptType;
  return deptTypes.includes(myDeptType);
}


// WEBPACK FOOTER //
// ./src/hooks/roleAuths.js